module.exports = __webpack_public_path__ + "static/media/Screen_Shot_5.6584c4a4.png";